import { createSelector } from '@ngrx/store';

import { BetslipType } from '../../betslip/core/betslip-type';
import { selectTokensStateContext } from '../../betslip/modules/reward-tokens/selectors';
import { getSelectedAndEligibleAccaBoost } from '../../betslip/modules/reward-tokens/services/linear-reward-tokens.utils';
import { betslipCurrentTypeSelector } from '../../betslip/modules/types/base/selectors';
import { AccaBoostRatioPipe } from './acca-boost-ratio.pipe';

export const accaBoostTokenSelector = createSelector(selectTokensStateContext, ({ eligibilityState, tokens, types }) => {
    return getSelectedAndEligibleAccaBoost(eligibilityState, tokens, types);
});

export const accaBoostTokenForCurrentTypeSelector = createSelector(accaBoostTokenSelector, betslipCurrentTypeSelector, (accaBoost, type) => {
    return type && type === BetslipType.Combo ? accaBoost : null;
});

export const isAccaBoostTokenSelector = createSelector(accaBoostTokenSelector, (token) => !!token);

const accaBoostRatioPipe = new AccaBoostRatioPipe();

export function getAccaBoostPercentageTitle(
    boostRatio: number | undefined,
    accaBoostPercentageTitle: string,
    isEnhancedLayoutEnabled: boolean,
    tokenType: any,
    expectedTokenType: any,
): string | undefined {
    return isEnhancedLayoutEnabled && tokenType === expectedTokenType
        ? accaBoostRatioPipe.transform(boostRatio, false, accaBoostPercentageTitle)
        : undefined;
}
